import { render, staticRenderFns } from "./news-aside.vue?vue&type=template&id=112b1bc7&scoped=true&"
import script from "./news-aside.vue?vue&type=script&lang=js&"
export * from "./news-aside.vue?vue&type=script&lang=js&"
import style0 from "./news-aside.vue?vue&type=style&index=0&id=112b1bc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b1bc7",
  null
  
)

export default component.exports